import { DoctorSimple } from '@dreryk/egabinet-personnel-frontend-api';

import { FormContextValues } from '@dreryk/react-common';
import { FormController, TextView } from '@dreryk/react-components';

import { PractitionerSafePresenter } from '~libs.desktop.shared.practitioner-safe-presenter';

import { prescriptionVisitsTranslationKeys } from '../../translations';

import { doctorSimpleLabelExtractor } from './PrescriptionVisitForm.utils';

type PrescriptionVisitPractitionerTextViewProps = Pick<
   FormContextValues<{ practitioner: DoctorSimple | null }>,
   'register'
>;

export const PrescriptionVisitPractitionerTextView = (
   props: PrescriptionVisitPractitionerTextViewProps
): JSX.Element => {
   return (
      <FormController<DoctorSimple> controller={props.register('practitioner')}>
         {({ value: practitioner }) => (
            <TextView label={prescriptionVisitsTranslationKeys.form.practitioner} testId={'practitioner'}>
               <PractitionerSafePresenter
                  testId={'practitioner'}
                  practitioner={{
                     displayName: doctorSimpleLabelExtractor(practitioner),
                     medicalLicenceNumber: practitioner.medicalLicenceNumber,
                  }}
                  type={'text'}
                  withIdentification
               />
            </TextView>
         )}
      </FormController>
   );
};
